var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":_vm.label,"items":_vm.available_divisions,"rules":_vm.rules,"prepend-icon":"fas fa-building"},model:{value:(_vm.Division),callback:function ($$v) {_vm.Division=$$v},expression:"Division"}})
}
var staticRenderFns = []

export { render, staticRenderFns }